import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface TaskType {
  id: string;
  name: string;
  code: string;
  category?: string;
  default_assignee_role?: string;
  estimated_duration_hours?: number;
  icon?: string;
  color?: string;
  is_active: boolean;
  display_order: number;
}

export const useTaskTypes = () => {
  const { data: taskTypes, isLoading } = useQuery({
    queryKey: ['task-types'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('task_types')
        .select('*')
        .eq('is_active', true)
        .order('display_order');

      if (error) throw error;
      return data as TaskType[];
    },
  });

  return {
    taskTypes: taskTypes || [],
    isLoading,
  };
};
